import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  persistPortraitSubject,
  readSelectedAiSelfieArtFromStorage,
  type PortraitSubject,
} from "../../../services/stylePromptResolver";
import { resolveStationRouteSlug } from "../../../utils/stationFlowStorage";

export type { PortraitSubject };
export { persistPortraitSubject, readPortraitSubject } from "../../../services/stylePromptResolver";

/**
 * People/Pets selection was removed from caricature-portrait.
 * Redirect any leftover /choose-portrait links to choose-option.
 */
const ChoosePortrait = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();

  useEffect(() => {
    const selectedRaw = localStorage.getItem("selectedStation");
    const fromSelected = selectedRaw ? JSON.parse(selectedRaw) : null;
    const fromStorage = JSON.parse(localStorage.getItem("stationData") || "{}");
    const stationData = fromSelected || fromStorage;
    const selectedArt =
      (location.state as { selectedArt?: unknown } | null)?.selectedArt ||
      readSelectedAiSelfieArtFromStorage();
    const stationSlug = resolveStationRouteSlug(
      stationData,
      slug,
      selectedArt as { name?: string } | null
    );

    persistPortraitSubject("people");
    navigate(`/${stationSlug || slug || "caricature-portrait"}/choose-option`, {
      replace: true,
      state: location.state ?? {
        stationData,
        selectedArt,
        portraitSubject: "people" as PortraitSubject,
      },
    });
  }, [location.state, navigate, slug]);

  return null;
};

export default ChoosePortrait;
